import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import type { AddResidentData } from '../AddResidentForm';
import { Input } from '@/shared';

// ---------------------------- Step 4 ----------------------------
interface AssignManagerProps {
  register: UseFormRegister<AddResidentData>;
  errors: FieldErrors<AddResidentData>;
}

export const ResidentAssignManagerForm: React.FC<AssignManagerProps> = ({
  register,
  errors,
}) => (
  <Input
    label="House Manager Email (optional)"
    {...register('managerEmail')}
    error={errors.managerEmail?.message}
  />
);
